import React, { FC, memo } from 'react';

import EditableListTab from 'components/ResqlExpert/SubmissionForm/EditableListTab';

const Source: FC = () => (
  <EditableListTab
    fieldName="information_sources"
    group="source"
    titleKey="tab_sources"
    hintKey="tab_sources_hint"
  />
);

export default memo(Source);
